import React from 'react';
import { drapcodeIcon } from '../../common/custom/icon-library';
import ConstantForm from '../common/ConstantForm';
import ParentCardNoCol from '../common/ParentCardNoCol';
import ListAppConstants from './ListAppConstants';

const AppConstants = ({
  projectId,
  constants,
  toggle,
  handleDelete,
  handleSubmit,
  showDerivedConstantLoader,
  updateCurrentConstantId,
  deleteFlag,
}) => {
  const showProjectConstants = () => {
    if (constants && constants.length > 0) {
      return (
        <ListAppConstants
          projectId={projectId}
          handleDelete={handleDelete}
          constants={constants}
          toggle={toggle}
          updateCurrentConstantId={updateCurrentConstantId}
          deleteFlag={deleteFlag}
        />
      );
    }
  };
  const showConstantForm = () => {
    if (constants && constants.length > 0) {
      return (
        <>
          <ConstantForm
            constantType=""
            constant={null}
            handleSubmit={handleSubmit}
            isCollection={false}
            showDerivedConstantLoader={showDerivedConstantLoader}
          />
        </>
      );
    }
  };
  return (
    <>
      <ParentCardNoCol bgColor="drapcode-violet" icon="form" title="App Constant">
        {showConstantForm()}
        {showProjectConstants()}
      </ParentCardNoCol>
    </>
  );
};

export default AppConstants;
